import React from 'react'
import {
    Box,
    FormControl,
    Grid,
    MenuItem,
    Select,
    TextField,
} from '@mui/material'
import { Moment } from 'moment'
import { FormInputLabel } from '@/shared/ui/input'
import { CalendarTextField } from '@/shared/ui/date'

interface EndDateSelectorProps {
    kedo: any
    endMode: 'date' | 'after'
    handleEndChange: (e: any) => void
    afterExecutions: number
    setAfterExecutions: (val: number) => void
    isValidNumericInput: (value: string, e: any) => boolean
    endDate: Date | null
    setEndDate: (date: Date | null) => void
    submitting: boolean
    getCurrentLocale: () => string
    isValidEndDate: (currentDate: any) => boolean
    isDateTime?: boolean
}

const EndDateSelector: React.FC<EndDateSelectorProps> = ({
    kedo,
    endMode,
    handleEndChange,
    afterExecutions,
    setAfterExecutions,
    isValidNumericInput,
    endDate,
    setEndDate,
    submitting,
    getCurrentLocale,
    isValidEndDate,
    isDateTime = true,
}) => {
    const handleDateChange = (newDate: Moment | null) => {
        if (!newDate) {
            setEndDate(null)
            return
        }

        if (isValidEndDate(newDate)) {
            setEndDate(new Date(newDate.format()))
        }
    }

    return (
        <Grid container spacing={2} alignItems="center">
            {/* End Mode Selector */}
            <Grid size={{ xs: 12, sm: 2 }}>
                <FormInputLabel>{kedo.t('End')}</FormInputLabel>
            </Grid>

            <Grid size={{ xs: 12, sm: 10 }}>
                <Grid container spacing={2} alignItems="center">
                    {/* Select 'date' or 'after' */}
                    <Grid size={{ xs: 12, sm: 4 }}>
                        <FormControl fullWidth size="small">
                            <Select value={endMode} onChange={handleEndChange}>
                                <MenuItem value="date">
                                    {kedo.t('On date')}
                                </MenuItem>
                                <MenuItem value="after">
                                    {kedo.t('time_after')}
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    {/* End date input or repetitions */}
                    <Grid size={{ xs: 12, sm: 8 }}>
                        {endMode === 'after' ? (
                            <Grid container spacing={1} alignItems="center">
                                <Grid size={4}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        type="number"
                                        value={afterExecutions}
                                        onChange={(e: any) => {
                                            const value = e.target.value
                                            if (isValidNumericInput(value, e)) {
                                                setAfterExecutions(
                                                    value === ''
                                                        ? 0
                                                        : parseInt(value)
                                                )
                                            }
                                        }}
                                    />
                                </Grid>
                                <Grid size={8}>
                                    <Box component="span" sx={{ ml: 1 }}>
                                        {kedo.t('Repetitions').toLowerCase()}
                                    </Box>
                                </Grid>
                            </Grid>
                        ) : (
                            <CalendarTextField
                                value={endDate}
                                onChange={handleDateChange}
                                locale={getCurrentLocale()}
                                disabled={submitting}
                                isDateTime={isDateTime}
                                shouldDisableDate={(day) =>
                                    !isValidEndDate(day)
                                }
                            />
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}
export default EndDateSelector
